// src/pages/ResetPassword.js
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './ResetPassword.module.css'; 
// import axios from 'axios';
import api from '../../api/axios';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage('❌ Passwords do not match');
      return;
    }
    // console.log('Submitting token:', token);
  // console.log('Submitting newPassword:', newPassword);


    try {
      const response = await api.post('/reset-password', {
        token,
        new_password: newPassword,
      }); // Adjust the endpoint as per your API
      

      if (response.status === 200) {
        setMessage('✅ Password reset successful. You can now log in.');
      } else {
        setMessage('❌ Something went wrong.');
      }
    } catch (error) {
      console.error('Reset error:', error);
      setMessage('❌ Invalid or expired token.');
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.title}>Reset Password</h2>
        <p className={styles.subtitle}>Enter your new password below.</p>

        <form onSubmit={handleSubmit}>
          <label className={styles.label}>New Password</label>
          <input
            type="password"
            className={styles.input}
            placeholder="********"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />

          <label className={styles.label}>Confirm New Password</label>
          <input
            type="password"
            className={styles.input}
            placeholder="********"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          <button className={styles.sendButton} type="submit">
            Reset Password
          </button>

          {message && <p style={{ marginTop: '15px' }}>{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
